

export const getSortOptions = (category) => {
    if (category === "Stories") return ['Best Match', 'Newest', 'Related Threats', 'Related Solutions', 'Rating', 'Views', 'Comments', 'Shares', 'Post Date'];
    if (category === "Actors") return ['Best Match', 'Trukno Pick', 'Latest Breach', 'Name', 'Related Breaches', 'Related Stories', 'Related Experts', 'Rating', 'Views', 'Comments', 'Shares', 'Post Date'];
    if (category === "Threats") return ['Best Match', 'Latest Breach', 'Trukno Pick', 'Related Breaches', 'Related Stories', 'Related Actors', 'Related Solutions', 'Related Companies', 'Related Experts', 'Rating', 'Views', 'Comments', 'Shares', 'Post Date'];
    if (category === "Solutions") return ['Best Match', 'Trukno Pick', 'Related Threats', 'Related Stories', 'Related Solutions', 'Related Companies', 'Related Experts', 'Rating', 'Views', 'Comments', 'Shares', 'Post Date'];
    if (category === "Companies") return ['Best Match', 'Newest', 'Related Stories', 'Related Actors', 'Related Threats', 'Related Solutions', 'Rating', 'Views', 'Comments', 'Shares', 'Post Date'];
    if (category === "Experts") return ['Best Match', 'Newest', 'Related Actors', 'Related Threats', 'Related Solutions', 'Rating', 'Views', 'Comments', 'Shares', 'Post Date'];
};

export const timeOptions = ['All', '1 Day', '3 Days', '7 Days', '14 Days', '30 Days', '3 Months', '6 Months', '12 Months', '24 Months', '36 Months'];

export function getSubCategoryOptions() {
    return [
        'Application Security',
        'Breach Testing & Simulation',
        'Consumer Security',
        'Cyber Crimes',
        'Cloud Security',
        'Data Security',
        'Endpoint Security',
        'Email Security',
        'Fraud Security',
        'Hardware Security',
        'Identity & Access',
        'Insider Threats',
        'IOT Security',
        'Mobile Security',
        'Network Security',
        'OT / ICS Security',
        'Phishing Attacks',
        'Physical Security',
        'Risk & Compliance',
        'Security Awareness & Training',
        'Security Operations',
        'Supply Chain Attacks',
        'Voice & Video Security',
        'Web Security',
        'Wireless Security',
        'Other'
    ];
}

export function getIndustryOptions() {
    return [
        'Advertising & Marketing',
        'Agriculture & Food',
        'Automotive',
        'Airline & Aerospace',
        'Casinos & Gambling',
        'Chemicals & Material',
        'Critical Infrastructure',
        'Cryptocurrency',
        'Education',
        'Electronics & Semiconductors',
        'Energy',
        'Finance',
        'Government',
        'Healthcare',
        'Industrial & Manufacturing',
        'Insurance',
        'Law Enforcement ',
        'Legal & Accounting Services',
        'Managed Service Provider (MSP)',
        'Media & Entertainment',
        'Non-Profit & Human Rights',
        'Oil & Gas',
        'Pharmaceuticals',
        'Real Estate & Construction',
        'Retail & E-Commerce',
        'Software & IT',
        'Sports',
        'Telecom',
        'Transportation',
        'Travel & Hospitality',
        'Utility',
        'Video Gaming '
    ];
}

export const companySizeOptions = () => {
    return [
        '1-10 employees',
        '11-50 employees',
        '51-200 employees',
        '201-500 employees',
        '501-1000 employees',
        '1001-5000 employees',
        '5001-10,000 employees',
        '10,001+ employees'
    ];
};

export const jobRoleOptions = () => {
    return [
        'IT & CYBER SECURITY ROLES',
        'CIO',
        'CISO',
        'CSO',
        'CTO',
        'Cyber Consultant',
        'IT - Applications',
        'IT - Cloud',
        'IT - Data Privacy',
        'IT - Database',
        'IT - Network',
        'IT - Mobile',
        'IT - Risk & Compliance',
        'IT - Security',
        'IT - Server',
        'IT - Storage',
        'IT - Support',
        'IT - Training',
        'IT - Operations',
        'IT - OT / ICS',
        'IT - Wireless',
        'SOC Threat Analyst',
        'SOC Engineer',
        'SOC Malware Forensics',
        'SOC Operations',
        'SOC Pen Testing',
        'GENERAL ROLES',
        'CEO',
        'Cyber Executive',
        'Engineer',
        'Finance',
        'Journalist',
        'Legal',
        'Marketing',
        'Product Management',
        'Professor',
        'Sales',
        'Sales Engineer',
        'Student',
        'Recruiter',
        'Other'
    ];
};

export const countryOptions = () => {
    return [
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua & Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas, The",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia & Herzegovina",
        "Botswana",
        "Brazil",
        "British Virgin Is.",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burma",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Cayman Islands",
        "Central African Rep.",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Comoros",
        "Congo, Dem. Rep.",
        "Congo, Repub. of the",
        "Cook Islands",
        "Costa Rica",
        "Cote d'Ivoire",
        "Croatia",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "East Timor",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "Gabon",
        "Gambia, The",
        "Gaza Strip",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea, North",
        "Korea, South",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia, Fed. St.",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "Netherlands Antilles",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "N. Mariana Islands",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Helena",
        "Saint Kitts & Nevis",
        "Saint Lucia",
        "St Pierre & Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome & Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Togo",
        "Tonga",
        "Trinidad & Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks & Caicos Is",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela",
        "Vietnam",
        "Virgin Islands",
        "Wallis and Futuna",
        "West Bank",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe"
    ];
};

export const jobSeniorityOptions = () => {
    return [
        'CXO',
        'VP',
        'Director',
        'Manager',
        'Staff',
        'Consultant'
    ];
};

export const statesOptions = () => {
    return [
        "Alabama",
        "Alaska",
        "American Samoa",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District Of Columbia",
        "Federated States Of Micronesia",
        "Florida",
        "Georgia",
        "Guam",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Marshall Islands",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Northern Mariana Islands",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Palau",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virgin Islands",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming"
    ];
};

export const feedbackOptions = () => {
    return [
        'General',
        'New Feature Request',
        'Suggest News Source',
        'Website Error / Issue',
        'User Profile Issues',
        'Content Issues'
    ];
};

export const mitreAttackOptions = () => {
    return [
        '01: Reconnaissance',
        '02: Resource Development',
        '03: Initial Access',
        '04: Execution',
        '05: Persistence',
        '06: Privilege Escalation',
        '07: Defense Evasion',
        '08: Credential Access',
        '09: Discovery',
        '10: Lateral Movement',
        '11: Collection',
        '12: Command & Control',
        '13: Exfiltration',
        '14: Impact'
    ];
};

export const technologyOptions = () => {
    return [
        'Windows (Endpoint OS)',
        'macOS (Endpoint OS)',
        'Linux (Endpoint OS)',
        'Office 365 (Productivity)',
        'Android (Mobile OS)',
        'iOS (Mobile OS)',
        'AWS (Cloud Computing)',
        'Azure (Cloud Computing)',
        'Docker (Container)',
        'Kubernetes (Container)',
        'Gitlab (Code Repository)',
        'GitHub (Code Repository)',
        'Bitbucket (Code Repository)'
    ];
};

export const malwareOptions = () => {
    return [
        'Locky (Ransomware)',
        'WannaCry (Ransomware)',
        'Ryuk (Ransomware)',
        'CryptoLocker (Ransomware)',
        'Petya (Ransomware)',
        'GandCrab (Ransomware)',
        'Dridex (Trojan)',
        'Gh0st (RAT)',
        'Zues (Trojan)',
    ];
};


